var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTronCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1999_12286)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M40.347 0H39.653C17.7533 0 0 17.9086 0 40C0 62.0914 17.7533 80 39.653 80H40.347C62.2467 80 80 62.0914 80 40C80 17.9086 62.2467 0 40.347 0Z",
    fill: "#EC0928"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18 17L38.4998 69L67 33.9959L56.7753 24.1932L18 17ZM51.9933 26.9635L42.4736 34.9601L27.4674 22.4142L51.9933 26.9635ZM40.7921 38.231L38.3247 58.8019L25.016 25.04L40.7921 38.231ZM55.9241 28.3452L60.7446 32.9639L47.5599 35.3708L55.9241 28.3452ZM60.1568 36.7269L44.2249 39.6356L41.8821 59.1718L60.1568 36.7269Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1999_12286"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 80,
    height: 80,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTronCircle);
export default __webpack_public_path__ + "static/media/tron-circle.3475d084b93928cf69c3835dfea9af53.svg";
export { ForwardRef as ReactComponent };